import SoSendMessageList from './soSendMessageList';
import SoSendMessageShow from './soSendMessageShow';
import SoSendMessageCreate from './soSendMessageCreate';

export default {
    list: SoSendMessageList,
    show: SoSendMessageShow,
    create: SoSendMessageCreate
}